import { render, staticRenderFns } from "./AmountFrequency.vue?vue&type=template&id=6efd75e6"
import script from "./AmountFrequency.vue?vue&type=script&lang=js"
export * from "./AmountFrequency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports